import React from "react";
import ChartComponent from "../index";

const ColumnChart = ({questionTitle, options}) => {
  return (
    <>
      <p className="title-2">{questionTitle}</p>
      <br></br>
      <ChartComponent options={options} />
    </>
  );
};

export default ColumnChart;